"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitDatePicker = exports.UiKitDatePickerInput = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const faCalendar_1 = require("@fortawesome/free-regular-svg-icons/faCalendar");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const consistency_1 = require("../../consistency");
exports.UiKitDatePickerInput = react_1.default.forwardRef((props, ref) => (react_1.default.createElement(react_2.InputGroup, null,
    react_1.default.createElement(react_2.InputRightElement, { pointerEvents: "none", fontSize: '14px' },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCalendar_1.faCalendar, color: consistency_1.consistency.gray60 })),
    react_1.default.createElement(react_2.Input, { autoComplete: "off", width: '100%', ref: ref, ...props, fontSize: '12px', lineHeight: '20px', fontWeight: '400', color: consistency_1.consistency.gray90 }))));
const UiKitDatePicker = (props) => {
    const { customInput = react_1.default.createElement(exports.UiKitDatePickerInput, null), dateFormat = 'yyyy/MM/dd', placeholderText = 'YYYY/MM/DD', popperPlacement = 'top-start', ...passThroughProps } = props;
    return (react_1.default.createElement(react_datepicker_1.default, { popperPlacement: popperPlacement, dateFormat: dateFormat, placeholderText: placeholderText, customInput: customInput, ...passThroughProps }));
};
exports.UiKitDatePicker = UiKitDatePicker;
